<template>
  <div>
    <v-dialog v-model="memoDialog" max-width="600">
      <v-card>
        <v-card-title class="pt-5 pl-5 pb-1 font-weight-bold"
          >간단 메모 관리</v-card-title
        >

        <v-card-text class="px-5 d-inline-block pb-0">
          <p class="mb-0 primary--text float-left pt-2">
            {{ name }} ({{ id }})
          </p>
          <v-btn
            small
            color="grey lighten-1"
            hide-details
            depressed
            class="white--text float-right"
            @click="deleteMemo"
            >삭제하기</v-btn
          >
        </v-card-text>

        <div class="px-5">
          <v-textarea
            v-model="memo"
            outlined
            no-resize
            full-width
            hide-details
            height="300"
          ></v-textarea>
        </div>

        <div v-if="memo_at && is_show_memo_at">
          <v-card-text class="px-5 pb-0 pt-2">
            <p class="mb-0 caption">
              마지막 저장 일시 : {{ memo_at }}
            </p></v-card-text
          >
        </div>

        <v-btn
          color="black"
          hide-details
          depressed
          class="white--text ml-5"
          @click="memoDialog = false"
          width="276"
          >닫기</v-btn
        >

        <v-btn
          color="primary"
          hide-details
          class="white--text ml-2 mt-5 mb-5 pl-4 pr-4 mr-5"
          depressed
          @click="save()"
          width="276"
          >저장</v-btn
        >
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data: () => {
    return {
      M,
      memoDialog: false,
      memo: null,
      serial_number: null,
      name: null,
      id: null,
      memo_at: null,
      is_show_memo_at: false,
    };
  },
  methods: {
    reset: function() {
      Object.assign(this.$data, this.$options.data());
    },
    show: async function(params) {
      this.reset();
      this.serial_number = params.serial_number;
      this.memo = params.memo;
      this.name = params.auth_member_info.name;
      this.id = params.auth_member_info.id;
      this.memo_at = params.memo_at;
      if (params.memo) {
        this.is_show_memo_at = true;
      }
      this.memoDialog = true;
    },
    save: async function(type) {
      try {
        await M.api(M.entry("/put/serials/memo", this.serial_number), {
          memo: this.memo,
        });
        this.$parent.setMemo(this.serial_number, this.memo);
        if (type != "delete") {
          alert("저장되었습니다.");
        }
        await this.$parent.$parent.$refs.searchComponent.execSearch(false);
        this.memoDialog = false;
      } catch (e) {
        this.$parent.setMemo(this.serial_number, this.memo);
        alert("저장 실패했습니다.");
        this.memoDialog = false;
      }
    },
    deleteMemo: async function() {
      if (confirm("메모를 삭제하시겠습니까?")) {
        this.memo = null;
        await this.save("delete");
        this.memoDialog = false;
      }
    },
  },
  mixins: [CommonMixin],
  created: async function() {},
};
</script>
